/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Building_The_Pause_ButtonInputs */

const en_learn_building_the_pause_button = /** @type {(inputs: Learn_Building_The_Pause_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Building the Pause button](/building-the-pause-button). What it takes to pause AI.`)
};

/**
* | output |
* | --- |
* | "[Building the Pause button](/building-the-pause-button). What it takes to pause AI." |
*
* @param {Learn_Building_The_Pause_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_building_the_pause_button = /** @type {((inputs?: Learn_Building_The_Pause_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Building_The_Pause_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_building_the_pause_button(inputs)
});